import styled from "styled-components";
import { Space } from "antd";

export const RootContainer = styled.div`
	text-align: center;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
  width: calc(100% - 32px);
  margin: 0 auto 32px;

	svg {
		cursor: pointer;
	}
`;

export const Title = styled.div`
	margin-bottom: 15px;

  color: #2A2A2A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`;

export const SocialWrapper = styled(Space)`
	gap: 15px !important;

	svg {
		width: 40px;
		height: auto;
	}
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 21px 0;
  margin-bottom: 12px;
`;

export const PhBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  width: 100%;
`

export const Phone = styled.a`
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
  text-decoration: none;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;

  border-radius: ${props => props.isLeft === "true" ? "8px 0px 0px 8px" : "0px 8px 8px 0px"};
  background: rgba(0, 0, 0, 0.50);
  backdrop-filter: blur(25px);
  padding: 8px;
`